import React from 'react';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';
import PropTypes from 'prop-types';
import './TimelineVertical.scss';

const TimelineVertical = ({ points, activeIndex, firstImage, secondImage }) => {
    const { ref, inView } = useInView({
        threshold: 0,
    });

    return (
        <div
            className={classNames('TimelineVertical', {
                'TimelineVertical--Active': inView,
            })}>
            <ul ref={ref} className="TimelineVertical__Points">
                {points.map((item, index) => {
                    return (
                        <li
                            className={classNames('TimelineVertical__Point', {
                                'TimelineVertical__Point--Active':
                                    parseInt(activeIndex) === index,
                            })}
                            key={index}>
                            <span className="TimelineVertical__Blob" />
                            <h2 className="TimelineVertical__PointTitle">
                                {item.title}
                            </h2>
                            <p className="TimelineVertical__PointText">
                                {item.text}
                            </p>
                        </li>
                    );
                })}
            </ul>
            <div className="TimelineVertical__Images">
                {firstImage && (
                    <div
                        className="TimelineVertical__Image TimelineVertical__Image--First"
                        style={{
                            backgroundImage: `url(${firstImage.sizes.mediumLarge})`,
                        }}
                    />
                )}
                {secondImage && (
                    <div
                        className="TimelineVertical__Image TimelineVertical__Image--Second"
                        style={{
                            backgroundImage: `url(${secondImage.sizes.mediumLarge})`,
                        }}
                    />
                )}
            </div>
        </div>
    );
};

TimelineVertical.propTypes = {
    points: PropTypes.array,
    activeIndex: PropTypes.any,
    firstImage: PropTypes.any,
    secondImage: PropTypes.any,
};

TimelineVertical.defaultProps = {
    points: [],
    activeIndex: 0,
};

export default TimelineVertical;
